export default __webpack_public_path__ + "static/media/Background_00028.a7f865ec.png";